export const langLocaleSelector = (state) => state?.globals?.langLocale;
export const profileSelector = (state) => state?.globals?.profile;
export const rolesSelector = (state) => state?.globals?.profile?.storeRoles;
export const storeInfoSelector = (state) => state?.globals?.storeInfo;
export const tokensSelector = (state) => state?.globals?.tokens;
export const bankDepositCountSelector = (state) => state?.globals?.bankDepositCount;
